import React from 'react';
import { motion } from 'framer-motion';
export function StarlightBackground() {
  // Generate random stars
  const stars = Array.from({
    length: 100
  }).map((_, i) => ({
    id: i,
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    size: Math.random() * 2 + 1,
    delay: Math.random() * 5,
    duration: Math.random() * 3 + 2
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-316">
      {stars.map(star => <motion.div key={star.id} className="absolute rounded-full bg-white" style={{
      top: star.top,
      left: star.left,
      width: star.size,
      height: star.size
    }} animate={{
      opacity: [0, 0.5, 0],
      scale: [0.5, 1, 0.5]
    }} transition={{
      duration: star.duration,
      repeat: Infinity,
      delay: star.delay,
      ease: 'easeInOut'
    }} data-id="element-317" />)}
    </div>;
}